import React, { useState } from 'react'
import ModalBasic from '../component/ModalBasic';
import BookingServices from '../../services/axiosServices/apiServices/BookingServices';
import { useNavigate } from "react-router-dom";
import SwalServices from '../../services/swalServices/SwalServices';
import ButtonLoader from '../../components/common/buttonLoader/ButtonLoader';
import { CommonValidationMessages } from '../../utils/Messages';
import { validate } from '../../utils/validation/CommonValidator';
import ValidationText from '../../utils/validation/ValidationText';

const BookingCancellation = ({ modalOpen, setModalOpen, bookingDetails, getBookingCancellationDetailsById }) => {

    const bookingServices = new BookingServices();
    const swalServices = new SwalServices();
    const [cancellationRescheduleDetails, setCancellationRescheduleDetails] = useState({ terminationReason: "",otherReason: "" })
    const [isLoading, setIsLoading] = useState(false);
    const [cancellationRescheduleValidation, setCancellationRescheduleValidation] = useState({
        terminationReason: [
            {
                type: "require",
                message: CommonValidationMessages.FieldRequired.replace("{0}", "Reason"),
            },
        ],
        name: [
            {
                type: "require",
                message: CommonValidationMessages.FieldRequired.replace("{0}", "Full Name"),
            },
        ],
        bankAccountNumber: [
            {
                type: "require",
                message: CommonValidationMessages.FieldRequired.replace("{0}", "Bank Account Number"),
            },
        ],
    });

    const [validStateForCancellationReschedule, setValidStateForCancellationReschedule] = useState({
        isValid: true,
        error: {},
    });

    const Navigate = useNavigate()


    const handleChange = (e) => {
        let { name, value } = e.target;
        const detail = { ...cancellationRescheduleDetails };
        const validations = { ...cancellationRescheduleValidation };
        const validState = { ...validStateForCancellationReschedule };
        const updatedErrors = { ...validState.error };

        detail[name] = value;

        if ( detail.terminationReason === "Others" )
            {
              validations.otherReason = [
                {
                  type: "require",
                  message: CommonValidationMessages.FieldRequired.replace(
                    "{0}",
                    "Other Reason"
                  ),
                },
              ];
            }
            
        setCancellationRescheduleDetails(detail);
        setCancellationRescheduleValidation(validations);
        setValidStateForCancellationReschedule({
            ...validState,
            error: updatedErrors,
        });
    };
    const handleClose = () => {
        setCancellationRescheduleDetails({ terminationReason: "" ,otherReason:""})
        setModalOpen(false);
    }




    const validateFieldsForCancellationReschedule = (key) => {
        const newValidState = validate(
            key,
            cancellationRescheduleDetails,
            cancellationRescheduleValidation,
            validStateForCancellationReschedule
        );
        setValidStateForCancellationReschedule(newValidState);
    };

    const   handleSubmit = () => {
        
        if (!bookingDetails || !cancellationRescheduleDetails?.terminationReason) {
          swalServices.Alert("Please provide cancellation reason.");
          return;
        }
      
        const request = {
          bookingId: bookingDetails[0].bookingId,
          eventId: bookingDetails[0].eventId,
          eventTimeslotId: bookingDetails[0].eventTimeSlotId,
          reasonForCancalltion: cancellationRescheduleDetails.terminationReason === "Others" ? cancellationRescheduleDetails.otherReason : cancellationRescheduleDetails.terminationReason,
          isRequestFor : 'Cancallation from admin',
          AttendeeName : bookingDetails[0].attendeeName,
          statusId: 3,
          promoCode: bookingDetails[0].promoCode
        };
        setIsLoading(true)
        bookingServices
          .submitAdminBookingCancellation(request)
          .then((response) => {
            if (response?.statusCode === 200 && response?.responseItem) {
              setIsLoading(false)
              setModalOpen(false)
              swalServices.Success("This booking has been cancelled!");
            } else {
              swalServices.Alert("Unable to cancel booking. Please try again.");
            }
          })

      };
      const referenceNos =
        bookingDetails?.[0]?.bookingReferenceNoAll
            ?.split(",")
            .map(ref => ref.trim())
            .filter(Boolean) || [];

        const isMultiple = referenceNos.length > 1;

      
    return (
        <>
           <ModalBasic
                id="booking-cancellation-modal"
                className="membership-add-edit-modal"
                modalOpen={modalOpen}
                setModalOpen={() => handleClose()}
                title="Booking Cancellation"
            >
                <div className="p-6">
                    <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-12">
                        <div className="highlight-text">
                            Cancelling this booking will cancel the following booking reference
                            {isMultiple ? " numbers " : " number "}
                            <strong>{referenceNos.join(", ")}</strong>
                            </div>

                            <div className="reason-box w-[70%] mt-4">
                                <label className="block text-gray-700 font-medium mb-2">
                                    Reason<span className="text-[#f93549]">*</span>
                                </label>

                                {/* Dropdown for reasons */}
                                <select
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-600"
                                    name="terminationReason"
                                    value={cancellationRescheduleDetails.terminationReason}
                                    onChange={handleChange}
                                    onBlur={() => validateFieldsForCancellationReschedule("terminationReason")}

                                >
                                    <option value="">-- Select Reason --</option>
                                    <option value="Medical Reasons (MC Required)">Medical Reasons (MC Required)</option>
                                    <option value="Change of Plans">Change of Plans</option>
                                    <option value="Wrong Ticket Selected">Wrong Ticket Selected</option>
                                    <option value="Duplicate Registration">Duplicate Registration</option>
                                    <option value="Others">Others (Please Indicate)</option>
                                </select>

                                <ValidationText
                                    error={validStateForCancellationReschedule.error.terminationReason}
                                />

                                {/* Show extra textbox if "Others" is selected */}
                                {cancellationRescheduleDetails.terminationReason === "Others" && (
                                    <div className="mt-3">
                                        <textarea
                                            type="text"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-600"
                                            placeholder="Please indicate your reason"
                                            name="otherReason"
                                            value={cancellationRescheduleDetails.otherReason || ""}
                                            onChange={handleChange}
                                            onBlur={() => validateFieldsForCancellationReschedule("otherReason")}
                                        />
                                        <ValidationText
                                            error={validStateForCancellationReschedule.error.otherReason}
                                        />
                                    </div>
                                )}


                            </div>

                            <div className="mt-4 flex justify-end">
                                {isLoading ? <ButtonLoader className="buttonload group relative rounded-md btn btn-red text-xl text-white focus:outline-none" /> : <button
                                    onClick={handleSubmit}
                                    className="hover:bg-blue-700 active:bg-blue-800 text-white font-semibold px-6 py-2 rounded-md transition duration-200  btn-red"
                                >
                                    Submit
                                </button>}
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBasic>
        </>
    )
}


export default BookingCancellation